import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./styles/LogoShowcaseSection.css";
import Logo from "../../../assets/images/Logo/LOGO.png";

const LogoShowcaseSection = () => {
  const navigate = useNavigate();

  return (
    <section className="brand-focus">
      <div className="brand-focus__bg brand-focus__bg--one" />
      <div className="brand-focus__bg brand-focus__bg--two" />

      <div className="brand-focus__container">
        <motion.div
          className="brand-focus__left"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <div className="brand-focus__panel">
            <div className="brand-focus__logo-wrap">
              <div className="brand-focus__logo-orbit brand-focus__logo-orbit--one" />
              <div className="brand-focus__logo-orbit brand-focus__logo-orbit--two" />
              <img
                src={Logo}
                alt="Company Logo"
                className="brand-focus__logo"
              />
            </div>


          </div>
        </motion.div>

        <motion.div
          className="brand-focus__right"
          initial={{ opacity: 0, x: 34 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          <div className="brand-focus__eyebrow">Focused service ecosystem</div>

          <h2 className="brand-focus__title">
            Wide breadth.
            <br />
            <span>Precision focus.</span>
          </h2>

          <p className="brand-focus__description">
            We bring together mission critical IT services under one focused
            approach helping businesses make smarter decisions, simplify
            complexity, and move forward with confidence.
          </p>

          <div className="brand-focus__metrics">
            <div className="brand-focus__metric">
              <strong>01</strong>
              <p>Business-aligned technology planning and execution.</p>
            </div>

            <div className="brand-focus__metric">
              <strong>02</strong>
              <p>Scalable services tailored to operational needs.</p>
            </div>
          </div>

          <div className="brand-focus__actions">
            <button
              className="brand-focus__cta brand-focus__cta--primary"
              onClick={() => navigate("/services")}
            >
              Explore Services
            </button>

            <button
              className="brand-focus__cta brand-focus__cta--secondary"
              onClick={() => navigate("/contact")}
            >
              Contact Team
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LogoShowcaseSection;
